const list = [
  { id: '1', name: 'Diretor' },
  { id: '2', name: 'Supervisor' },
  { id: '3', name: 'Corretor' },
  { id: '4', name: 'Auxiliar Adm.' },
  { id: '8', name: 'Telefonista/Atendente' },
  { id: '9', name: 'Gerente (Lider Equipe)' },
];

export default list;
